import React, { useState } from "react";
import onClickOutside from "react-onclickoutside";
import detailsIcon from "../icons/details-24px.svg";
import "./UserSettings.css";
// import { Link } from "found";
import { useNavigate } from "react-router-dom";
import { useThemeUpdate } from "../contexts/ThemeContext";
import { useTheme } from "../contexts/ThemeContext";
// import { useNavigate } from "react-router-dom";
import { commitLocalUpdate } from "react-relay";
import environment from "../Environment";
import { func } from "prop-types";
import { ListBoxes20, Grid20 } from "@carbon/icons-react";
import { updateLocalSetting } from "../Environment";

function Dropdown(props) {
    let [isMenuActivated, setIsMenuActivated] = useState(false);
    const { email } = props.user;
    const toggleTheme = useThemeUpdate();
    const theme = useTheme();
    const navigate = useNavigate();

    const user = props.user;
    const { isPremium } = user;
    const { view } = props.settings;

    Dropdown.handleClickOutside = () => {
        setIsMenuActivated(false);
    };

    function logoutClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue([], "filterTerms");
            record.setValue([], "selectedLeads");
            record.setValue(false, "isAdvancedSearch");
            record.setValue("", "hasPhrase");
            record.setValue("", "withoutWords");
            record.setValue("", "withWords");
            record.setValue("", "searchScope");
            record.setValue("", "searchTime");
            record.setValue("{}", "tagData");
            record.setValue("", "metaSourceName");
            record.setValue("", "metaDescription");
            record.setValue([], "selectedSourceId");
            record.setValue([], "selectedPostId");
        });
        props.logout();
    }

    const menuOnClick = (event) => {
        setIsMenuActivated(!isMenuActivated);
    };

    function onSepiaClick(e) {
        e.preventDefault();
        toggleTheme("sepia");
    }

    function onBlackClick(e) {
        e.preventDefault();
        toggleTheme("dark");
    }

    function onLightClick(e) {
        e.preventDefault();
        toggleTheme("light");
    }

    function onAccountClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isAccountView");
            record.setValue(false, "isSubListView");
            record.setValue(false, "isProfileView");
        });
            navigate("/settings");
    }

    function onSubscriptionsClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isAccountView");
            record.setValue(true, "isSubListView");
            record.setValue(false, "isProfileView");
            navigate("/settings");
        });
    }

    function onProfileClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");

            record.setValue(false, "isAccountView");
            record.setValue(false, "isSubListView");
            record.setValue(true, "isProfileView");
            navigate("/settings");
        });
    }

    function onMagazineClick(e) {
        e.preventDefault();
        updateLocalSetting("view", "magazine");
    }

    function onGridClick(e) {
        e.preventDefault();
        updateLocalSetting("view", "grid");
    }

    function onSortNewestClick(e) {
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(["-created"], "order");
        });
    }

    function onSortOldestClick(e) {
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(["created"], "order");
        });
    }

    let menuState = isMenuActivated ? "activated" : "not-activated";

    return (
        <div className="menu-box">
            <div className={`menu-control`} onClick={menuOnClick}>
                <span
                    className={`dropdown-user-email theme-${theme.foreground}`}
                >
                    {email}
                </span>
                <img
                    className="icon-drop-down my-eighth-step"
                    src={detailsIcon}
                />
            </div>
            <div
                className={`dropdown-content dropdown-${menuState} theme-${theme.secondary}`}
            >
                {/* <Link
					className={`theme-${theme.paragraph}`}
					to="/settings"
				>
				    Subscriptions	
				</Link>
				<Link
					className={`theme-${theme.paragraph}`}
					to="/settings"
				>
					Profile
				</Link> */}

                {/* <Link to="/settings" className={`theme-${theme.paragraph}`}>Account</Link> */}
                <a
                    target="_blank"
                    onClick={onSubscriptionsClick}
                    className={`theme-${theme.paragraph}`}
                >
                    Subscriptions
                </a>
                <a
                    target="_blank"
                    onClick={onProfileClick}
                    className={`theme-${theme.paragraph}`}
                >
                    Profile
                </a>
                <a
                    target="_blank"
                    onClick={onAccountClick}
                    className={`theme-${theme.paragraph}`}
                >
                    Account
                </a>
                <a
                    target="_blank"
                    onClick={onSortNewestClick}
                    className={`theme-${theme.paragraph}`}
                >
                    Newest First
                </a>

                <a
                    target="_blank"
                    onClick={onSortOldestClick}
                    className={`theme-${theme.paragraph}`}
                >
                    Oldest First
                </a>

                <a
                    target="_blank"
                    href="https://docs.thefeedgram.com/docs/tutorial/quick-start/"
                    className={`theme-${theme.paragraph}`}
                >
                    Help
                </a>

                <span onClick={onMagazineClick} className={`view-grid-button`}>
                    <ListBoxes20 /> <span className={`theme-${theme.paragraph}`}> Magazine </span>
                </span>

                <span onClick={onGridClick} className="view-grid-button">
                    <Grid20 /> <span className={`theme-${theme.paragraph}`}>Grid</span>
                </span>

                <div className="menu-seperator"></div>
                <div className="color-themes">
                    <div className="menu-button">
                        <div
                            onClick={onLightClick}
                            className="color-box white"
                        ></div>
                    </div>
                    <div className="menu-button">
                        <div
                            onClick={onBlackClick}
                            className="color-box black"
                        ></div>
                    </div>
                    <div className="menu-button">
                        <div
                            onClick={onSepiaClick}
                            className="color-box sepia"
                        ></div>
                    </div>
                </div>

                <div>
                    <a
                        className={`theme-${theme.paragraph}`}
                        href="#"
                        onClick={logoutClick}
                    >
                        {" "}
                        Signout{" "}
                    </a>
                </div>
            </div>
        </div>
    );
}

const clickOutsideConfig = {
    handleClickOutside: () => Dropdown.handleClickOutside,
};

function MenuItem(props) {
    return (
        <div>
            <a href="#">{props.label}</a>
        </div>
    );
}

export default onClickOutside(Dropdown, clickOutsideConfig);
